import React from 'react'
import { Box, useTheme, useMediaQuery } from '@material-ui/core'
import NumberFormat from 'react-number-format'

const ENumberFormat = ({
  value = 0,
  currency = 'HKD',
  type,
  color,
  fontSize,
  isModal,
  noCurrency,
  ...rest
}) => {
  const theme = useTheme()

  const isMobile = useMediaQuery(theme.breakpoints.down('xs'))

  return type === 'simple' ? (
    <NumberFormat
      displayType="text"
      value={value || 0}
      prefix={`${noCurrency ? '' : currency}${currency === 'CNY' ? '¥' : ''}`}
      thousandSeparator
      decimalScale={2}
      thousandsGroupStyle={currency === 'CNY' ? 'wan' : 'thousand'}
      {...rest}
    />
  ) : (
    <Box component="span" color={color || 'grey.400'}>
      <Box component="span" fontWeight={600} fontSize={isModal && !isMobile ? 20 : 16}>
        {`${value < 0 ? '-' : ''}${currency || 'HKD'}${currency === 'CNY' ? '¥' : ''}`}
      </Box>
      <NumberFormat
        displayType="text"
        value={value < 0 ? -value : value || 0}
        // prefix={`${currency}${currency === 'CNY' ? '¥' : '$'}`}
        thousandSeparator
        decimalScale={2}
        thousandsGroupStyle={currency === 'CNY' ? 'wan' : 'thousand'}
        style={{
          fontSize: fontSize || 16,
          fontWeight: 'bold',
        }}
        {...rest}
      />
    </Box>
  )
}

export default ENumberFormat
